import GroupScreen from "./screens/group/GroupScreen.js";
import SimpleSearchScreen from "./screens/simpleSearch/SimpleSearchScreen.js";
import ItemScreen from "./screens/item/ItemScreen.js";
import ItemInfoScreen from "./screens/itemInfo/ItemInfoScreen.js";
import MissingRelationshipScreen from "./screens/support/MissingRelationshipScreen/index.js";
export default {
  BlueprintRoutes: {
    groupScreen: GroupScreen,
    simpleSearchScreen: SimpleSearchScreen,
    itemScreen: ItemScreen,
    infoScreen: ItemInfoScreen,
    missingRelScreen: MissingRelationshipScreen
  }
};